module.exports = __webpack_public_path__ + "static/media/progman_21.061427f9.ico";